import { InitialState } from '../state';
import { AppReducer } from './app-reducer';
import { isTrendlineEnabled } from '../state/dashboard-state';
import { getTrendlineIdentifier } from '../lib/trends-helpers';

export const dashboardReducer: AppReducer<'Dashboard'> = (state = InitialState.Dashboard, action): typeof state => {
    switch (action.type) {
        case 'Dashboard/AutoRedirectBannerShown':
            return {
                ...state,
                autoRedirectBannerShown: true,
            };
        case 'Dashboard/AutoRedirectBannerDismissed':
            return {
                ...state,
                autoRedirectBannerShown: false,
            };
        case 'Dashboard/TrendCardDaysChanged':
            return {
                ...state,
                trendCardDays: action.payload.days,
            };
        case 'Dashboard/DeviceTrendCardDaysChanged':
            return {
                ...state,
                deviceTrendCardDays: action.payload.days,
            };
        case 'Dashboard/TrendListItemCheckboxClicked': {
            return {
                ...state,
                trendLinesEnabled: {
                    ...state.trendLinesEnabled,
                    [getTrendlineIdentifier(action.payload.channelId, action.payload.deviceId)]: !isTrendlineEnabled(
                        state.trendLinesEnabled,
                        action.payload.channelId,
                        action.payload.deviceId
                    ),
                },
            };
        }
        case 'Dashboard/TrendListItemCheckboxClear': {
            return {
                ...state,
                trendLinesEnabled: {},
            };
        }
        case 'Dashboard/TrendListItemEntered':
            return {
                ...state,
                hoveredTrendline: {
                    channelId: action.payload.channelId,
                    deviceId: action.payload.deviceId,
                },
            };
        case 'Dashboard/TrendListItemLeft': {
            return {
                ...state,
                hoveredTrendline: undefined,
            };
        }
        case 'Dashboard/inActiveLogOut': {
            return {
                ...state,
                inActiveLogOut: action.payload.inActiveLogOut,
            };
        }
        case 'Dashboard/LocationRefresh':
            return {
                ...state,
                isLocationRefresh: action.payload.isRefresh,
            };

        default:
            return state;
    }
};
